// Sharing: the system share sheet where the browser has one, the clipboard, and the codes of share
// links.
import { SHARE_CODE_LENGTH, shareCodeFrom } from '@wbwl/contract'
import { fmt } from './game.ts'

/** The line a challenge goes out with, from either share sheet. */
export const challengeLine = (edition: number, rank: string, total: number): string =>
  `Letters on Fire No. ${edition}: I made ${rank} with ${fmt(total)}. Think you can beat it?`

/** A new share link's code (/s/<code>). */
export const newShareCode = (): string => shareCodeFrom(crypto.getRandomValues(new Uint8Array(SHARE_CODE_LENGTH)))

/** Opens the system share sheet: 'unavailable' when the browser has none (or it failed). */
export async function nativeShare(text: string): Promise<'shared' | 'cancelled' | 'unavailable'> {
  if (!navigator.share) return 'unavailable'
  try {
    await navigator.share({ text })
    return 'shared'
  } catch (e) {
    return (e as Error).name === 'AbortError' ? 'cancelled' : 'unavailable'
  }
}

/** Copies text; false when the browser refused. */
export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    return false
  }
}
